import FormRegister from "./Form";

export default function Register() {
	return (
		<>
			<FormRegister />
		</>
	);
}
